import ChatAction from "@/chatbot-library/ChatAction"

class ChatButton extends ChatAction {
  get name() {
    return "button"
  }

  getResponseContent() {
    return this.data.label
  }
}

export default ChatButton
